import React from 'react';
import {css} from '@emotion/react';
import {SyncLoader, ClipLoader} from 'react-spinners';

const styleSpiner = css`
	display: block;
	margin: 0 auto;
`;

function MichassAccueil() {
	return (
		<div className="w-full flex justify-center">
			<ClipLoader color={'#5a12ab'} css={styleSpiner} size={50} />
		</div>
	);
}

export default MichassAccueil;
